import { createTheme } from '@material-ui/core/styles'

const theme = createTheme({
  typography: {
    fontFamily: ['Nunito Sans', 'Arial', 'sans-serif'].join(','),
  },
})

export default theme
